import React, { useEffect, useState } from "react";
import {
   getECLToken,
   sourceOneRESTFetchConfig,
   sourceOneRestURL,
} from "../../../../utilities/requests";
import { ECLLoader } from "../../../../eclComponents";

export default function FilePreview({ node }) {
   const [content, setContent] = useState(null);
   const [contentType, setContentType] = useState(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);

   useEffect(() => {
      if (node?.data?.object_type === "file") {
         getECLToken().then((token) => {
            fetch(sourceOneRestURL, {
               ...sourceOneRESTFetchConfig(token),
               body: JSON.stringify({
                  query_type: "file_data",
                  object: node.id,
               }),
            })
               .then((res) => {
                  const contentType = res.headers.get("content-type");
                  setContentType(contentType);
                  if (contentType.startsWith("text")) {
                     return [res.text(), contentType];
                  } else if (contentType.startsWith("image")) {
                     return [res.blob(), contentType];
                  } else {
                     setContent(null);
                     throw new Error("Non-supported type");
                  }
               })
               .then(async (res) => {
                  if (res[1].startsWith("text")) {
                     setContent(await res[0]);
                  } else if (res[1].startsWith("image")) {
                     const objectURL = URL.createObjectURL(await res[0]);
                     setContent(objectURL);
                  }
                  setLoading(false);
               })
               .catch((error) => {
                  setError(error.message);
               });
         });
      }
   }, [node]);

   if (loading || error || !content || !contentType) {
      return <ECLLoader message={error} />;
   }

   if (contentType.startsWith("text"))
      return <p style={{ whiteSpace: "pre-wrap" }}>{content}</p>;
   if (contentType.startsWith("image")) return <img src={content} />;
}
